module.exports = __webpack_public_path__ + "img/logo_kunteSAC.14bc5aa0.png";